import requestFunctions from "../../functions/requestFunctions";


export const state = {
  COUNTRIES_ITEM: {},
  COUNTRIES_LIST: [],
  COUNTRIES_TABLE_DATA: [],
  COUNTRIES_ARRAY_DATA: [],
  COUNTRIES_TOTAL_ROWS: 0
}

export const getters = {
  GET_COUNTRIES_ITEM: (state) => {
    return state.COUNTRIES_ITEM;
  },
  GET_COUNTRIES_LIST: (state) => {
    return state.COUNTRIES_LIST;
  },
  GET_COUNTRIES_TABLE_DATA: (state) => {
    return state.COUNTRIES_TABLE_DATA;
  },
  GET_COUNTRIES_ARRAY_DATA: (state) => {
    return state.COUNTRIES_ARRAY_DATA;
  },
  GET_COUNTRIES_TOTAL_ROWS: (state) => {
    return state.COUNTRIES_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_COUNTRIES_ITEM(state, item) {
    state.COUNTRIES_ITEM = item;
  },

  UPDATE_COUNTRIES_LIST(state, list) {
    
    state.COUNTRIES_LIST = list.data;

    state.COUNTRIES_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.COUNTRIES_TABLE_DATA = [];
    state.COUNTRIES_ARRAY_DATA = [];

    list.forEach(el => {

      state.COUNTRIES_TABLE_DATA.push({
        'uuid' : el.uuid,
        'id'   : el.id,
        'name' : el.name,
        'created_at' : el.created_at,
        'updated_at' : el.updated_at
      });

      state.COUNTRIES_ARRAY_DATA.push({
        id: el.id,
        uuid: el.uuid,
      });
    });
  },
}

export const actions = {

  async FETCH_COUNTRIES_ITEM({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/countries/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_COUNTRIES_ITEM', response.data);
      return response.data;
    }
  },

  async FETCH_COUNTRIES_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.tradeanalytic.ru/v1/countries';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_COUNTRIES_LIST', response.data);
      return response.data;
    }
  },

  async FETCH_COUNTRIES_CREATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/countries';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_COUNTRIES_UPDATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/countries/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_COUNTRIES_DELETE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/countries/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}